import { render, staticRenderFns } from "./PartnersHowItWorks.vue?vue&type=template&id=518ada56&"
import script from "./PartnersHowItWorks.vue?vue&type=script&lang=js&"
export * from "./PartnersHowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports